import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';

import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {VisaStatus} from "../type/visa-status";

@Component({
    selector: 'app-company-visa-status-add',
    templateUrl: './company-visa-status-add.component.html',
})
export class CompanyVisaStatusAddComponent implements OnInit {
    node = 'visa-status';
    visaStatus: VisaStatus = VisaStatus;

    constructor(
        private dataService: DataService,
        private apiService: ApiService,
        private location: Location
    ) {}

    ngOnInit() {
        this.dataService.refresh();
    }

    onFormSubmit(formData) {
        var data = {
            visa_status : formData.value.visa_status,
            visa_status_class : formData.value.visa_status_class
        }
        this.apiService.postNew(this.node, data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: Company Status added successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/company-visa-status/company-visa-status-add.component.ts